import Vue from 'vue'
import App from './App.vue'

//Service Worker
import './registerServiceWorker'

//Vue modules
import router from './router'
import store from './store'
import i18n from './i18n'

//import 3rd parties lib
import Buefy from 'buefy'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import L from 'leaflet'
import moment from 'moment'

moment.locale(process.env.VUE_APP_I18N_LOCALE)
Vue.prototype.moment = moment

// Config
import './config/backend'
import './config/filters'
import './config/styles'
import firebaseMessaging from './config/firebase'
import preferences from './config/preferences'

//Sentry
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ['localhost', process.env.VUE_APP_PROD, /^\//]
        })
    ],
    tracesSampleRate: 1.0
})

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.prototype.$messaging = firebaseMessaging

Vue.use(CKEditor)
Vue.use(Buefy, {
    defaultIconPack: 'fa'
})

new Vue({
    router,
    store,
    i18n,
    beforeCreate() {
        this.$store.dispatch('initialiseStore')
    },
    render: (h) =>
        h(App, {
            props: preferences
        })
}).$mount('#app')
